<template>
  <div class="container">
    <Input
      label="Имя"
      v-model="input"
      error-text="Обязательное поле"
      :validator="(value) => value.length > 0"
      :min-label-width="minWidth"
      placeholder="placeholder"
    />

    <Input
      type="date"
      label="Дата рождения"
      v-model="date"
      error-text="error"
      :validator="() => false"
      :min-label-width="minWidth"
    />

    <Input
      type="time"
      label="Время рождения"
      v-model="time"
      error-text="error"
      :validator="() => false"
      :min-label-width="minWidth"
    />

    <Input
      label="Область"
      v-model="input"
      error-text="Обязательное поле"
      :validator="(v) => v.length > 3"
      :min-label-width="minWidth"
    />

    <Input
      label="Город"
      caption="Название населенного пункта"
      v-model="input"
      error-text="Обязательное поле"
      :validator="(v) => v.length > 3"
      :min-label-width="minWidth"
    />

    <Button label="Enabled" @click="onClick" />
    <Button label="Disabled" disabled @click="onClick" />
  </div>
</template>

<script lang="ts" setup>
import { ref } from "vue";
import Input from "@/components/Input.vue";
import Button from "@/components/Button.vue";

const input = ref("");
const date = ref("");
const time = ref("");

const minWidth = 90;

// eslint-disable-next-line
const onClick = () => console.log("qwe");
</script>

<style>
.container {
}
</style>
